import { render, staticRenderFns } from "./Teaching-and-Talks.vue?vue&type=template&id=a438d4ce"
import script from "./Teaching-and-Talks.vue?vue&type=script&lang=js"
export * from "./Teaching-and-Talks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports